module.exports = __webpack_public_path__ + "static/media/tax_summary_icon.ba046a15.svg";